import client from "../services/api"

type MessageType = {
    message: string; // همیشه باید پر شود
  };
  
  type WithTitle = {
    title: string;
    ticket_id?: never; // ticket_id نباید وجود داشته باشد
  };
  
  type WithTicketId = {
    ticket_id: string;
    title?: never; // title نباید وجود داشته باشد
  };
  
  export type Ticket = MessageType & (WithTitle | WithTicketId);

export const createTickets = (ticket: Ticket | FormData) => {
    return client.post('/tickets',ticket,)
}

export const getAllTickets = (page?: number, per_page?: number) => {
    return client.get('/tickets', {params: {page, per_page, order: 'id', type_order:'desc'}})
}

export const getUserTickets = (page?: number, per_page?: number) => {
    return client.get('/tickets/by-user', {params: {page, per_page,order: 'id', type_order:'desc'}})
}

export const getUserTicketId = (id: any) => {
    return client.get(`/tickets/by-user`, {params: {id}})
}

export const closeConversation = (ticketId: number | string) => {
    return client.get(`/tickets/close/${ticketId}`)
}

export const getTicketById = (id?: number | string) => {
    return client.get(`/tickets`, {params: {id}})
}

export const getTicketConversation = (ticketId?: number | string) => {
    return client.get(`/tickets/conversation/${ticketId}`)
}

export const ticketNotificationsCountQueryKey = ['ticket', 'notifications', 'count'] as const

/**
 * تعداد پیام‌های خوانده‌نشده‌ای که ادمین یا ربات ایساج برای کاربر ارسال کرده‌اند
 * GET /tickets/notifications/count => { notification_count: number }
 */
export const getTicketNotificationCount = async (): Promise<number> => {
    try {
        const { data } = await client.get('/tickets/notifications/count')
        return Number(data?.notification_count) || 0
    } catch {
        return 0
    }
}